import { initActions, networkActions } from '@lifesize/nucleus';
import { ClientTypes } from '@lifesize/constants';
import { Store } from 'redux';
import { Global } from '../state/Global';

function initializeNucleus(store: Store<Global>) {
  const dispatch = store.dispatch;
  dispatch(
    initActions.initialize({
      environment: process.env.REACT_APP_DOMAIN,
      xmppEnabled: false,
      psemsEnabled: false,
      cssEnabled: false,
      callHistoryEnabled: false,
      loadContactsOnLogin: false,
      callsEnabled: false,
      directMediaEnabled: false,
      clientInfo: {
        clientType: ClientTypes.ADMIN
      }
    }),
  );
  // Are we online or offline currently
  dispatch(
    navigator && navigator.onLine ?
      networkActions.online() :
      networkActions.offline()
  );
}

export default initializeNucleus;
